export default __webpack_public_path__ + "static/media/logo.ed1c40e0.svg";